import React, { useContext } from 'react';
import ProjectContainer from '../../components/containers/ProjectContainer';
import { Components } from './styled';
import ProjectTextField from '../../components/inputs/ProjectTextField';
import { useNavigate } from 'react-router-dom';
import useFormTextState from '../../hooks/useFormTextState';
import { isValidEmail } from '../../utils/validation';
import { getUserByEmail } from '../../api/user';
import { ActivityIndicatorContext } from '../../providers/ActivityIndicatorProvider/context';
import { ToastContext } from '../../providers/ToastProvider/context';
import { getProjectErrorForCode } from '../../utils/errors';
import { ProjectErrors } from '../../utils/errors/types';

const UserLookup = () => {
  const navigate = useNavigate();

  const { setIsLoading } = useContext(ActivityIndicatorContext);
  const { showErrorToast } = useContext(ToastContext);

  const userQueryProps = useFormTextState('');

  const onSearchByID = (id: string | undefined) => {
    navigate(`/user-lookup/${id}`);
  };

  const _onSearch = async () => {
    const queryIsEmail = isValidEmail(userQueryProps.value);
    if (userQueryProps.value && queryIsEmail) {
      setIsLoading(true);
      const result = await getUserByEmail(userQueryProps.value);
      setIsLoading(false);
      if (result && result?.length) {
        onSearchByID(result);
      } else {
        showErrorToast(getProjectErrorForCode(ProjectErrors.noUserFoundWithEmail));
      }
    } else {
      onSearchByID(userQueryProps.value);
    }
  };

  return (
    <ProjectContainer title={'User Lookup'}>
      <Components.Container>
        <Components.SearchHeader>
          <Components.FieldWrapper>
            <Components.FieldLabel>Search by user ID or email</Components.FieldLabel>
            <Components.SearchUserWrapper>
              <ProjectTextField submitOnEnter={_onSearch} {...userQueryProps} placeholder={'Enter ID or email'} />
              <Components.SearchButton onClick={_onSearch}>Search</Components.SearchButton>
            </Components.SearchUserWrapper>
          </Components.FieldWrapper>
        </Components.SearchHeader>
      </Components.Container>
    </ProjectContainer>
  );
};

export default UserLookup;
